import { create } from "zustand";

export type PerformanceTier = "high" | "medium" | "low";

type PerformanceSettingsState = {
  tier: PerformanceTier;
  setTier: (tier: PerformanceTier) => void;
};

export const usePerformanceSettings = create<PerformanceSettingsState>((set) => ({
  tier: "high",
  setTier: (tier) => set((state) => (state.tier === tier ? state : { tier })),
}));
